import isEmpty from 'lodash/isEmpty';
import pick from 'lodash/pick';
import merge from 'lodash/merge';
import { priceToFloat, getBrandName, store, startLoading, setCircularProductData, setError, stopLoading, ACTION_TYPES, SprykerProductsAll, SprykerDdcConfig, getCTAClickEventParams, triggerCtaClickEvent, parseJsonResponse, CircularProductTypes, ETabType, ECarouselRelation } from '@pes-ui/utils';
import { CR } from '../UI/product-selector/constants';
import { getCountry, getLanguage } from '../../globals/utils/helpers';
export const softwareDocumentsToSoftwareInfo = (softwareDocuments, labels) => {
  if (!isEmpty(labels)) {
    return Object.assign(Object.assign({}, pick(labels, [
      'availableVersionsLabel',
      'operatingSystemsLabel',
      'languageLabel',
      'formatLabel',
      'sizeLabel',
      'dateLabel',
      'versionLabel',
      'downloadLabel',
      'viewLabel',
    ])), { softwareDocuments });
  }
  return null;
};
const requestCrProductSelectorAvailability = (selectorConfig) => fetch(selectorConfig.scUrl, {
  headers: { Authorization: selectorConfig.token },
}).then((res) => parseJsonResponse(res));
export const setProductSelectorAvailability = async (selectorConfig, productSelectorConfig) => {
  let showProductSelector;
  if (productSelectorConfig.type === CR) {
    const { status } = await requestCrProductSelectorAvailability(selectorConfig);
    showProductSelector = status;
  }
  else {
    showProductSelector = true;
  }
  return showProductSelector;
};
export const formatPrice = (price) => (price ? priceToFloat(price) : 'undefined');
export const gatherDataForViewItemAnalyticsEvent = (productId, productInfo, ctaArea, productAvailabilityInfo, isApc) => {
  var _a, _b, _c, _d, _e;
  const price = formatPrice(isApc ? (_b = (_a = productAvailabilityInfo === null || productAvailabilityInfo === void 0 ? void 0 : productAvailabilityInfo.prices) === null || _a === void 0 ? void 0 : _a[productId]) === null || _b === void 0 ? void 0 : _b.activePriceValue : ctaArea === null || ctaArea === void 0 ? void 0 : ctaArea.price);
  const quantity = 1;
  return {
    ecommerce: {
      currency: (_c = ctaArea === null || ctaArea === void 0 ? void 0 : ctaArea.currency) !== null && _c !== void 0 ? _c : 'EUR',
      value: Number(price) * quantity || 'undefined',
      items: [
        {
          item_brand: (_d = productInfo === null || productInfo === void 0 ? void 0 : productInfo.brand) !== null && _d !== void 0 ? _d : '',
          item_id: productId !== null && productId !== void 0 ? productId : '',
          item_name: (_e = productInfo === null || productInfo === void 0 ? void 0 : productInfo.description) !== null && _e !== void 0 ? _e : '',
          item_category: '',
          index: 0,
          item_variant: '',
          price,
          quantity,
        },
      ],
    },
  };
};
export const checkForLongWordInString = (pillars, threshold) => pillars.some((pillar) => pillar.pillarLabel.split(' ').some((word) => word.length > threshold));
export const checkForShowMore = (pillars, isLongWordPresent) => {
  const pillarsPerRow = isLongWordPresent ? 3 : 4;
  const isShowMoreRequired = pillars.length > pillarsPerRow;
  return { isShowMoreRequired, pillarsPerRow };
};
export const fetchProductData = async ({ productId, localeCode, circularType, isPbs, }) => {
  store.dispatch(startLoading({ type: ACTION_TYPES.START_LOADING }));
  const countryCode = getCountry(localeCode);
  const languageCode = getLanguage(localeCode);
  try {
    const [productsAllResponse, ddcConfigResponse] = await Promise.all([
      SprykerProductsAll.getProductsAll({
        productId,
        languageCode,
        countryCode,
        brand: getBrandName(),
      }),
      SprykerDdcConfig.getDdcConfig({
        languageCode,
        countryCode,
        brand: getBrandName(),
      }),
    ]);
    if (productsAllResponse.error) {
      throw productsAllResponse.error;
    }
    const { data } = store.getState().product;
    let productsAllData = productsAllResponse.result;
    if (isPbs) {
      const { ctaArea, links, offlineStores } = data[CircularProductTypes.LINEAR].base;
      const updatedBase = Object.assign(Object.assign({}, productsAllResponse.result.base), { ctaArea,
        links,
        offlineStores });
      productsAllData = merge({}, productsAllResponse.result, { base: updatedBase });
    }
    store.dispatch(setCircularProductData(merge({}, { circularType }, productsAllData, { ddc: Object.assign(Object.assign({}, ddcConfigResponse.result), { productId }) })));
    store.dispatch(stopLoading({ type: ACTION_TYPES.STOP_LOADING }));
  }
  catch (error) {
    console.error(`[PES]: Error fetching product data:\n${error.message}`);
    store.dispatch(setError(error));
  }
};
export const addPDPCTAClickGAEvent = (pdpClickGAEventParams) => {
  const { name, category, url, position } = pdpClickGAEventParams;
  const ctaClickGAParams = getCTAClickEventParams(name, category, url, position);
  triggerCtaClickEvent(ctaClickGAParams);
};
export const StickyBarMapping = {
  [ECarouselRelation.compatibleSoftware]: ETabType.SOFTWARE_CAROUSEL,
  [ECarouselRelation.crossSellLife]: ETabType.LIFECYCLE_CAROUSEL,
  [ECarouselRelation.upsell]: ETabType.EXPLORE_CAROUSEL,
  [ECarouselRelation.crosssell]: ETabType.FREQUENTLY_BOUGHT_CAROUSEL,
};
export const getStickyBarMapping = (relationType) => {
  return StickyBarMapping[relationType];
};
